import { render, staticRenderFns } from "./MemberDetailItemPopupLayout.vue?vue&type=template&id=275ac616&scoped=true"
import script from "./MemberDetailItemPopupLayout.vue?vue&type=script&lang=js"
export * from "./MemberDetailItemPopupLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275ac616",
  null
  
)

export default component.exports